export enum CategoryType {
  COMPONENT_DEFINITION = 'COMPONENT_DEFINITION'
}
